<div class="app-content content">
    <div class="content-wrapper">
        <div class="content-header row mb-1">
            <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
        </div>
        <ng-container mCardHeaderTitle>
            <ng-template #modalContent let-close="close">


                <form #f1="ngForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="SaveCustomer(f1.form.valid)">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ model.action }}</h5>
                        <button type="button" class="close" (click)="close()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-body">
                            <div class="form-group">
                                <input type="hidden" id="idCustomer" name="idCustomer" [(ngModel)]="model.idCustomer"
                                    value=0 #idCustomer="ngModel">
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="firstName">Full Name *</label>
                                        <input type="text" id="customerFirstName" class="form-control border-primary"
                                            placeholder="Full Name" [(ngModel)]="model.customerFirstName"
                                            name="customerFirstName" #customerFirstName="ngModel" required>
                                        <small class="form-text text-muted danger"
                                            *ngIf="!customerFirstName.valid && f1.submitted">First
                                            Name is required.</small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">GST No</label>
                                        <input type="text" id="customerGSTNO" class="form-control border-primary"
                                            placeholder="GST No" [(ngModel)]="model.customerGSTNO" name="customerGSTNO"
                                            #customerGSTNO="ngModel">

                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">Email Id</label>
                                        <input type="email" id="customerEmail" class="form-control border-primary"
                                            placeholder="Email Id" [(ngModel)]="model.customerEmail"
                                            name="customerEmail" #customerEmail="ngModel">

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">Contact No </label>
                                        <input type="text" id="customerContact" class="form-control border-primary"
                                            placeholder="Contact No" [(ngModel)]="model.customerContact"
                                            name="customerContact" #customerContact="ngModel">

                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="userinput1">Address </label>
                                        <input type="text" id="customerAddress" class="form-control border-primary"
                                            placeholder="Address" [(ngModel)]="model.customerAddress"
                                            name="customerAddress" #customerAddress="ngModel">

                                    </div>
                                </div>



                            </div>


                        </div>


                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-outline-secondary">Save</button>
                    </div>
                </form>

            </ng-template>

        </ng-container>
        <div class="content-body">
            <!-- <ngx-spinner bdColor = "rgba(0,0,0,0.5)" size = "medium" color = "#fff" type = "line-spin-fade" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner> -->
            <app-custom-loader-c></app-custom-loader-c>


            <section id="drag-area">

                <div class="row">
                    <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
                        <m-card [options]="options" (reloadFunction)="reloadProjectInfo($event)">

                            <ng-container mCardBody>

                                <form #f="ngForm" (keydown.enter)="$event.stopPropagation()"
                                    (ngSubmit)="$event.stopPropagation()">

                                    <div class="form-body">


                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="firstName">Select Customer *</label>
                                                    <ng-select [items]="customerarray"
                                                        style=" border: 1px solid #666ee8" [searchable]="true"
                                                        bindLabel="customerFullName" id="selectcustomer"
                                                        placeholder="Select Customer" [(ngModel)]="model.selectcustomer"
                                                        [virtualScroll]="true"
                                                        (change)="bindformcustomer(model.selectcustomer)"
                                                        name="selectcustomer" #selectcustomer="ngModel" required>
                                                    </ng-select>
                                                    <small class="form-text text-muted danger"
                                                        *ngIf="!selectcustomer.valid && f.submitted">Please
                                                        select Customer.</small>

                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <a (keydown.enter)="$event.preventDefault()" (click)="addcustomer()"
                                                        class="btn btn-primary btn-sm gap_contact"
                                                        style="margin-top: 6%;color:aliceblue">
                                                        <i class="d-md-none d-block feather ft-plus white"></i><span
                                                            class="d-md-block d-none">Add
                                                            Customer</span></a>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="form-group">
                                                    <label for="firstName"></label>
                                                </div>
                                            </div>

                                        </div>



                                        <ng-container *ngIf="showcustomer">
                                            <div class="form-actions text-right">
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="div-custom-header"
                                                            for="PatientInformation">Customer Information </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="FirstName">Full Name
                                                            :</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label
                                                            for="FirstName">{{customermodel.customerFirstName}}</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="customerGSTNO">GST
                                                            No:</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label
                                                            for="customerGSTNO">{{customermodel.customerGSTNO}}</label>
                                                    </div>
                                                </div>


                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="EmailId"><b>Email Id
                                                                :</b></label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label for="EmailId">{{customermodel.customerEmail}}</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label" for="customerContact">Contact
                                                            No:</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label
                                                            for="customerContact">{{customermodel.customerContact}}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <label class="div-custom-label"
                                                            for="customerAddress">Address:</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <p>{{customermodel.customerAddress}}</p>
                                                    </div>
                                                </div>

                                            </div>


                                            <div class="form-actions text-right">
                                            </div>
                                            <ng-container>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="div-custom-header"
                                                                for="bill"><b>Bill</b></label>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                          <br><br>
                                                          <div class="checkboxsas">
                                                            <label>
                                                              <input type="checkbox" name="isIgstBill" [(ngModel)]="model.isIgstBill">
                                                              IGST Bill
                                                            </label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <label for="billType"> Type *</label>
                                                            <select id="billype" class="form-control"
                                                                style=" border: 1px solid #666ee8"
                                                                [(ngModel)]="model.billType" name="billType"
                                                                #billType="ngModel" required>

                                                                <option value="Rent">Rent</option>
                                                                <option value="Repair">Repair</option>

                                                            </select>
                                                            <small class="form-text text-muted danger"
                                                                *ngIf="f.submitted && model.billType==undefined">Please
                                                                select Bill Type.</small>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <label for="billDate"> Date *</label>
                                                            <input type="date" class="form-control border-primary"
                                                                [(ngModel)]="model.billDate" name="billDate"
                                                                #billDate="ngModel" [max]="maxdate" required />
                                                            <small class="form-text text-muted danger"
                                                                *ngIf="!billDate.valid && f.submitted">Please
                                                                bill date.</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-2">
                                                        <div class="form-group">
                                                            <label for="rentBillDeposit">Deposit</label>
                                                            <input type="number" class="form-control border-primary"
                                                                [(ngModel)]="model.rentBillDeposit" name="Deposit" min="0"
                                                                placeholder="Deposit" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group">
                                                            <label for="Remark">Remark </label>
                                                            <input type="text" class="form-control border-primary"
                                                                [(ngModel)]="model.remark" name="Remark"
                                                                placeholder="Remark" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-actions text-right">
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="div-custom-header" for="billItems"><b>Bill
                                                                    Items</b></label>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="row">
                                                        <div class="col-md-3">
                                                            <div class="form-group">
                                                                <label for="productItemDescription">Description
                                                                    *</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="form-group">
                                                                <label for="productItemSerialNo">Serial No</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">
                                                                <label for="productHSN">HSN/SAC</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">
                                                                <label for="productGST">GST%</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">
                                                                <label for="productQty">Qty</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">
                                                                <label for="productToalGSTAmount">GST Amount</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">
                                                                <label for="productAmount"> Rate *</label>

                                                            </div>
                                                        </div>

                                                        <div class="col-md-1">
                                                            <div class="form-group">
                                                                <label for="productTotalAmount">Amount </label>
                                                            </div>
                                                        </div>



                                                    </div>
                                                </div>

                                                <div *ngFor="let obj of billItems; let i=index">
                                                    <div *ngIf="obj.operationState !='d'" class="row">
                                                        <div class="col-md-3">
                                                            <div class="form-group">

                                                                <input type="text" #productDescription="ngModel"
                                                                    class="form-control border-primary"
                                                                    [placeHolder]="placeholder"
                                                                    (keypress)="updateOperationStateForBillItem(i);"
                                                                    [(ngModel)]="billItems[i].productDescription"
                                                                    placeholder="Description"
                                                                    name="productDescription{{i}}" required>
                                                                <small class="form-text text-muted danger"
                                                                    *ngIf="(billItems[i].productDescription=='' || billItems[i].productDescription==undefined) && f.submitted">Please
                                                                    enter
                                                                    Item .</small>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <div class="form-group">

                                                                <input type="text" class="form-control border-primary"
                                                                    [(ngModel)]="billItems[i].productSerialNumber"
                                                                    placeholder="SerialNo"
                                                                    name="productSerialNumber{{i}}"
                                                                    (keypress)="updateOperationState(i);"
                                                                    #productSerialNumber="ngModel">

                                                            </div>
                                                        </div>

                                                        <div class="col-md-1">
                                                            <div class="form-group">

                                                                <input type="text" class="form-control border-primary"
                                                                    [(ngModel)]="billItems[i].productHSN"
                                                                    placeholder="HSN/SAC" name="productHSN{{i}}"
                                                                    (keypress)="updateOperationState(i);"
                                                                    #productHSN="ngModel">

                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">

                                                                <input type="number" class="form-control border-primary"
                                                                    [(ngModel)]="billItems[i].productGST"
                                                                    placeholder="GST" min=0 name="productGST{{i}}"
                                                                    #productGST="ngModel"
                                                                    (keypress)="updateOperationState(i);"
                                                                    (change)="calculatetotal()"
                                                                    (keypress)="calculatetotal()">

                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">

                                                                <input type="number" class="form-control border-primary"
                                                                    min=1 [(ngModel)]="billItems[i].productQty"
                                                                    placeholder="Qty" name="productQty{{i}}"
                                                                    #productQty="ngModel"
                                                                    (keypress)="updateOperationState(i);"
                                                                    (change)="updateOperationState(i);"
                                                                    (change)="calculatetotal()"
                                                                    (keypress)="calculatetotal()">

                                                            </div>
                                                        </div>
                                                        <div class="col-md-1">
                                                            <div class="form-group">

                                                                <input type="number" class="form-control border-primary"
                                                                    min=1 readonly
                                                                    [(ngModel)]="billItems[i].productToalGSTAmount"
                                                                    placeholder="GST Amount"
                                                                    name="productToalGSTAmount{{i}}"
                                                                    #productToalGSTAmount="ngModel"
                                                                    (keypress)="updateOperationState(i);"
                                                                    (change)="updateOperationState(i);"
                                                                    (change)="calculatetotal()"
                                                                    (keypress)="calculatetotal()">

                                                            </div>
                                                        </div>

                                                        <div class="col-md-1">
                                                            <div class="form-group">

                                                                <input type="number" class="form-control border-primary"
                                                                    min=1 [(ngModel)]="billItems[i].productRate"
                                                                    placeholder="Rate" name="productRate{{i}}"
                                                                    #productRate="ngModel"
                                                                    (keypress)="updateOperationState(i);"
                                                                    (change)="updateOperationState(i);"
                                                                    (change)="calculatetotal()"
                                                                    (keypress)="calculatetotal()" required>

                                                                <small class="form-text text-muted danger"
                                                                    *ngIf="f.submitted && (billItems[i].productRate=='' || billItems[i].productRate==undefined)">Please
                                                                    enter
                                                                    rate.</small>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-1">
                                                            <div class="form-group">

                                                                <input type="number" class="form-control border-primary"
                                                                    min=1 [(ngModel)]="billItems[i].productTotalAmount"
                                                                    placeholder="Amount "
                                                                    (keypress)="updateOperationState(i);"
                                                                    (change)="updateOperationState(i);"
                                                                    name="productTotalAmount{{i}}"
                                                                    #productTotalAmount="ngModel"
                                                                    (change)="calculateammounttotal(i)">

                                                            </div>
                                                        </div>


                                                        <div class="col-md-1">
                                                            <div class="zommin form-group">

                                                                <a class="danger delete ">
                                                                    <i (click)="RemoveForm(i)"
                                                                        style="padding: 10%; font-size: 1.9rem;"
                                                                        class="la la-trash-o"></i>
                                                                </a>
                                                            </div>



                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-3">

                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>

                                                    <div class="col-md-1">
                                                        <div class="zommin form-group">
                                                            <a>

                                                                <img (click)="AddForm()" style="    padding-left: 10%;
                                  margin-top: -44%;" src="../../../../../assets/images/icons/plusicon.png">

                                                            </a>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class="div-custom-header"
                                                                for="Payments"><b>Payment</b></label>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div *ngFor="let obj1 of paymentsarray; let i=index">

                                                    <div *ngIf="obj1.operationState !='d'">
                                                        <div class="form-group">
                                                            <div class="row">

                                                                <div class="col-md-3">
                                                                    <div class="form-group">
                                                                        <label for="payment-gateway">Payment Method
                                                                        </label>
                                                                        <select class="form-control border-primary"
                                                                            [(ngModel)]="paymentsarray[i].payMode"
                                                                            name="payMode{{i}}" placeholder="payMode"
                                                                            #payMode="ngModel"
                                                                            (change)="updateOperationStateForpayment(i);">
                                                                            <option value="">Select payment Method
                                                                            </option>
                                                                            <option value="By Cash">By Cash</option>
                                                                            <option value="By Cheque">By Cheque</option>
                                                                            <option value="By RTGS/NEFT">By RTGS/NEFT
                                                                            </option>
                                                                            <option value="By UPI">By UPI</option>
                                                                        </select>

                                                                    </div>
                                                                </div>
                                                                <div class="col-md-2">
                                                                    <div class="form-group">
                                                                        <label for="paidAmount">Amount </label>
                                                                        <input type="number"
                                                                            class="form-control border-primary"
                                                                            [(ngModel)]="paymentsarray[i].paidAmount"
                                                                            (keypress)="updateOperationStateForpayment(i);"
                                                                            (focusout)="CalculatTotalPaidAmount();updateOperationStateForpayment(i);"
                                                                            name="paidAmount{{i}}"
                                                                            placeholder="PaidAmount"
                                                                            (change)="CalculatTotalPaidAmount()" />
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-3">
                                                                    <div class="form-group">
                                                                        <label for="paymentDate">Payment Date</label>
                                                                        <input class="form-control border-primary"
                                                                            [(ngModel)]="paymentsarray[i].paymentDate"
                                                                            [max]="maxdate"
                                                                            (change)="updateOperationStateForpayment(i);"
                                                                            name="paymentDate{{i}}"
                                                                            placeholder="paymentDate" type="date"
                                                                            required />
                                                                        <small class="form-text text-muted danger"
                                                                            *ngIf="paymentsarray[i].paymentDate=='' || paymentsarray[i].paymentDate==undefined">Please
                                                                            select payment date
                                                                            .</small>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-3"
                                                                    *ngIf="(paymentsarray[i].payMode=='By RTGS/NEFT')||(paymentsarray[i].payMode=='By UPI')">
                                                                    <div class="form-group">
                                                                        <label for="transactionId">Transaction
                                                                            Id</label>
                                                                        <input type="text"
                                                                            class="form-control border-primary"
                                                                            [(ngModel)]="paymentsarray[i].transactionId"
                                                                            (keypress)="updateOperationStateForpayment(i);"
                                                                            name="transactionId{{i}}"
                                                                            placeholder="Transaction Id" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-1">
                                                                    <div class="zommin form-group">
                                                                        <a class="danger delete " title="Delete">
                                                                            <i (click)="RemoveFormPaymentsarray(i)"
                                                                                style="padding-top: 31%;
                                        font-size: 1.9rem;" class="la la-trash-o"></i>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div *ngIf="paymentsarray[i].payMode=='By Cheque'">
                                                                <div class="row">
                                                                    <div class="col-md-5">
                                                                        <div class="form-group">
                                                                            <label for="bankName">Bank Name</label>
                                                                            <input type="text"
                                                                                class="form-control border-primary"
                                                                                [(ngModel)]="paymentsarray[i].bankName"
                                                                                (keypress)="updateOperationStateForpayment(i);"
                                                                                name="bankName{{i}}"
                                                                                placeholder="Bank Name" />

                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-5">
                                                                        <div class="form-group">
                                                                            <label for="branchName">Branch Name</label>
                                                                            <input type="text"
                                                                                class="form-control border-primary"
                                                                                [(ngModel)]="paymentsarray[i].branchName"
                                                                                (keypress)="updateOperationStateForpayment(i);"
                                                                                name="branchName{{i}}"
                                                                                placeholder="Branch Name" />
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-5">
                                                                        <div class="form-group">
                                                                            <label for="chequeNumber">Cheque
                                                                                Number</label>
                                                                            <input type="text"
                                                                                class="form-control border-primary"
                                                                                [(ngModel)]="paymentsarray[i].chequeNumber"
                                                                                (keypress)="updateOperationStateForpayment(i);"
                                                                                name="chequeNumber{{i}}"
                                                                                placeholder="Cheque Number" />

                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-5  ">
                                                                        <div class="form-group">
                                                                            <label for="ifscCode">IFSCCode</label>
                                                                            <input type="text"
                                                                                class="form-control border-primary"
                                                                                [(ngModel)]="paymentsarray[i].ifscCode"
                                                                                name="ifscCode{{i}}"
                                                                                (keypress)="updateOperationStateForpayment(i);"
                                                                                placeholder="IFSCCode" />
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div>

                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                    </div>
                                                    <div class="col-md-2">

                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group">

                                                        </div>
                                                    </div>
                                                    <div class="zommin col-md-1">
                                                        <a title="Add">

                                                            <img (click)="AddFormPaymentsarray()" style="    padding-left: 10%;
                                margin-top: -44%;" src="../../../../../assets/images/icons/plusicon.png">

                                                        </a>

                                                    </div>
                                                </div>
                                                <div class="form-actions text-right">
                                                </div>





                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <div class="form-group">
                                                            <label class="div-custom-label"
                                                                for="totalAmountIncGST">Total Price: </label>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group">
                                                            <label>{{model.totalAmountIncGST}} </label>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group">
                                                            <label class="div-custom-label" for="totalpaidAmount">Total
                                                                Paid Amount</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group">
                                                            <label
                                                                for="totalpaidAmount">{{currency}}{{model.totalpaidAmount}}</label>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="row">

                                                    <div class="col-md-3">
                                                        <div class="form-group">
                                                            <label class="div-custom-label"
                                                                for="totalAmountIncGST">Balance Amount</label>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group">
                                                            <label>{{currency}}{{model.balanceAmount}} </label>

                                                        </div>
                                                    </div>



                                                </div>



                                                <div class="form-actions text-right">

                                                    <button type="button" (click)="cancel()"
                                                        class="btn btn-warning mr-1">
                                                        <i class="feather ft-x"></i> Cancel
                                                    </button>
                                                    <button type="submit" (keydown.enter)="$event.stopPropagation()"
                                                        (click)="saveBill(f.form.valid)" class="btn btn-primary">
                                                        <i class="la la-check"></i> Save
                                                    </button>

                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </form>
                            </ng-container>
                        </m-card>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>